"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import React from "react";
import Api from "../../api/api";
import reactUtils from "../../react_utils";
import Auth from "../../util/auth";
import { visibilityIcon, visibilityOffIcon } from "../ui/visibility_icons";
import ToolbarLink from "./toolbar_link";
import { markDuplicateIcon } from "../ui/mark_duplicate_icons";
const bem = reactUtils.makeBem("page-toolbar");
const PageToolbar = React.createClass({
  render: function() {
    const showEmailButton = !!Auth._currentUser.account.settings.documents_viewer_doctype_grouping_enabled;
    return /* @__PURE__ */ React.createElement("div", { "data-component": "PageToolbar", className: bem("__bar") }, /* @__PURE__ */ React.createElement("div", { className: bem("__action_icons") }, this.zoomInLink(), this.zoomOutLink(), this.downloadLink(), this.downloadAllLink(), this.duplicateLink(), this.rotateLeftLink(), this.rotateRightLink(), this.splitLink(), this.mergeLink(), this.annotateLink()), /* @__PURE__ */ React.createElement("div", { className: bem("__action_buttons") }, this.illegibleButton(), this.toggleHiddenButton(), showEmailButton && this.viewEmailButton()));
  },
  viewEmailButton: function() {
    const indexAuditSplitEnabled = Api.Account.currentSettings().index_audit_split_enabled;
    const title = indexAuditSplitEnabled ? "Re-Index" : "View Email";
    return /* @__PURE__ */ React.createElement(
      "a",
      {
        onClick: this.props.viewEmail,
        className: bem("__action_button", "__view_email"),
        title
      },
      title
    );
  },
  iconLink: function(icon, enabled, action, href, title, active = false, label = null) {
    return /* @__PURE__ */ React.createElement(ToolbarLink, __spreadValues({}, { icon, enabled, action, href, title, active, label }));
  },
  zoomInLink: function() {
    return this.iconLink(
      "zoom-in",
      this.props.canZoomIn,
      this.props.zoomIn,
      void 0,
      "Zoom In - Alt+= or +(Numpad)"
    );
  },
  zoomOutLink: function() {
    return this.iconLink(
      "zoom-out",
      this.props.canZoomOut,
      this.props.zoomOut,
      void 0,
      "Zoom Out - Alt+- or -(Numpad)"
    );
  },
  downloadAllLink: function() {
    if (this.props.downloadAllURL) {
      return this.iconLink(
        "page-export-pdf",
        true,
        void 0,
        this.props.downloadAllURL,
        "Download All Documents"
      );
    }
  },
  downloadLink: function() {
    if (Auth.getCurrentUser().managed_indexer) return null;
    else {
      const enabled = !this.props.attachmentIsProcessing;
      return this.iconLink(
        "download",
        enabled,
        void 0,
        this.props.downloadURL,
        "Download Document"
      );
    }
  },
  rotateLeftLink: function() {
    if (this.props.allowsEditing) {
      const enabled = !this.props.attachmentIsProcessing;
      return this.iconLink(
        "rotate-left",
        enabled,
        this.props.rotateLeft,
        void 0,
        "Rotate Left - Left Arrow Key"
      );
    }
  },
  rotateRightLink: function() {
    if (this.props.allowsEditing) {
      const enabled = !this.props.attachmentIsProcessing;
      return this.iconLink(
        "rotate-right",
        enabled,
        this.props.rotateRight,
        void 0,
        "Rotate Right - Right Arrow Key"
      );
    }
  },
  splitLink: function() {
    if (this.props.allowsEditing && this.props.canSplit) {
      return this.iconLink(
        "split-page",
        true,
        this.props.split,
        void 0,
        "Split From Document",
        false
      );
    }
  },
  mergeLink: function() {
    if (this.props.allowsEditing && this.props.canMerge) {
      return this.iconLink(
        "merge-page",
        true,
        this.props.merge,
        void 0,
        "Merge to Previous",
        false
      );
    }
  },
  duplicateLink: function() {
    if (this.props.allowsEditing) {
      return this.iconLink(
        "page-copy",
        true,
        this.props.duplicate,
        void 0,
        "Duplicate Document"
      );
    }
  },
  annotateLink: function() {
    const settings = Api.Account.currentSettings();
    if (this.props.allowsEditing && settings.document_annotation_enabled) {
      return this.iconLink(
        "annotate",
        true,
        this.props.annotate,
        void 0,
        "Annotate Document",
        this.props.annotating
      );
    }
  },
  illegibleButton: function() {
    if (this.props.canMarkIllegible) {
      return /* @__PURE__ */ React.createElement(
        "a",
        {
          onClick: () => this.props.markIllegible(),
          className: bem("__action_button"),
          title: "Mark Illegible - Alt+T"
        },
        this.props.markedIllegible ? visibilityIcon() : visibilityOffIcon(),
        /* @__PURE__ */ React.createElement("span", null, this.props.markedIllegible ? "Legible" : "Illegible")
      );
    }
  },
  toggleHiddenButton: function() {
    if (this.props.canToggleHidden) {
      return /* @__PURE__ */ React.createElement(
        "a",
        {
          onClick: () => this.props.toggleHidden(),
          className: bem("__action_button"),
          title: "Hide - Alt+H"
        },
        markDuplicateIcon(),
        /* @__PURE__ */ React.createElement("span", null, "Hide")
      );
    }
  }
});
export default PageToolbar;
